export default __webpack_public_path__ + "static/media/ic_requests.2d1ac085.svg";